import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  addDays,
  detectPreset,
  formatRangeLabel,
  isSingleDay,
  rangeForPreset,
  toISODate
} from '../utils/dateRange';
import './DateRangeBar.css';

const PRESETS = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yest' },
  { id: 'weekend', label: 'Weekend' },
  { id: 'week', label: '7 days' },
  { id: 'month', label: 'Month' },
  { id: 'year', label: 'Year' },
  { id: 'all', label: 'All' }
];

function DateRangeBar({ dateFrom, dateTo, preset, onChange }) {
  const today = toISODate(new Date());
  const activePreset = preset || detectPreset(dateFrom, dateTo);
  const singleDay = isSingleDay(dateFrom, dateTo);

  const apply = (next) => {
    onChange({
      preset: next.preset || detectPreset(next.dateFrom, next.dateTo),
      dateFrom: next.dateFrom,
      dateTo: next.dateTo
    });
  };

  const shiftDay = (days) => {
    if (!singleDay) return;
    const next = addDays(dateFrom, days);
    apply({ preset: 'custom', dateFrom: next, dateTo: next });
  };

  return (
    <div className="date-range-bar">
      <div className="date-range-chips" role="group" aria-label="Date range">
        {PRESETS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`chip ${activePreset === item.id ? 'active' : ''}`}
            onClick={() => apply(rangeForPreset(item.id))}
          >
            {item.label}
          </button>
        ))}
      </div>

      {singleDay && (
        <div className="day-stepper">
          <button type="button" className="day-step" onClick={() => shiftDay(-1)} aria-label="Previous day">
            <ChevronLeft size={18} />
          </button>
          <span className="day-step-label">{formatRangeLabel(activePreset, dateFrom, dateTo)}</span>
          <button
            type="button"
            className="day-step"
            onClick={() => shiftDay(1)}
            disabled={dateFrom >= today}
            aria-label="Next day"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      )}

      {!singleDay && (
        <div className="date-range-label">{formatRangeLabel(activePreset, dateFrom, dateTo)}</div>
      )}

      <div className="date-range-fields">
        <label>
          From
          <input
            type="date"
            value={dateFrom}
            max={dateTo || today}
            onChange={(e) => apply({
              preset: 'custom',
              dateFrom: e.target.value,
              dateTo: dateTo || e.target.value
            })}
          />
        </label>
        <label>
          To
          <input
            type="date"
            value={dateTo}
            min={dateFrom}
            onChange={(e) => apply({
              preset: 'custom',
              dateFrom: dateFrom || e.target.value,
              dateTo: e.target.value
            })}
          />
        </label>
      </div>
    </div>
  );
}

export default DateRangeBar;
